<div>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Alert!</h5>
    </div>
    <div class="modal-body text-center">
      {{ data.btnTitle1 }}
    </div>
    <div class="modal-footer d-block mx-auto">
      <button type="button" class="btn btn-primary" (click)="ChanageStatus()">
        Yes
      </button>
      <button type="button" class="btn btn-cancel" (click)="close()">No</button>
    </div>
  </div>
</div>
